// extracted by mini-css-extract-plugin
module.exports = {"bookmarkContainer":"Bookmarks_bookmarkContainer__2jHX0","show":"Bookmarks_show__frXVl","bookmark":"Bookmarks_bookmark__8q5Nv","active":"Bookmarks_active__2Txkx"};